module.exports = __webpack_public_path__ + "36a06c27d338dd7006b65d8714ae5335.png";